import { useState } from 'react';
import type { FaqItem } from '@/mocks/community';

interface Props {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: Props) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
      {items.map((item, idx) => {
        const open = openIndex === idx;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(open ? -1 : idx)}
              className="flex w-full items-center justify-between gap-4 px-4 md:px-5 py-4 text-left"
              aria-expanded={open}
            >
              <span className={`text-sm md:text-base font-semibold ${open ? 'text-primary-700' : 'text-foreground-950'}`}>
                {item.q}
              </span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform duration-300 ${
                  open ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-100 text-foreground-600'
                }`}
              >
                <i className="ri-add-line"></i>
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ease-in-out ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
            >
              <div className="overflow-hidden">
                <p className="px-4 md:px-5 pb-4 text-sm leading-relaxed text-foreground-600">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}